import { EmpresaVO } from './empresa-vo.model';
import { ProdutoIncentivadoVO } from './produto-incentivado-vo.model';

export class EmpresaProdutoAntigoVO {

  empresa: EmpresaVO;
  produtos: ProdutoIncentivadoVO[];

  constructor(init?: Partial<EmpresaProdutoAntigoVO>) {
    Object.assign(this, init);
  }

}
